import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FnConsolidatedService } from '../../services/fn-consoldate.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPagination } from 'src/app/shared/models/pagination';
import { DatePipe } from '@angular/common';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';

@Component({
  selector: 'app-fn-status-modal',
  templateUrl: './fn-status-modal.component.html',
  styleUrls: ['./fn-status-modal.component.scss'],
})
export class FnStatusModalComponent implements OnInit {
  statusForm!: FormGroup;
  @Output() changeStatus = new EventEmitter<any>();
  pagination!: IPagination;
  serviceType?: 'consolidatedItem' | 'consolidated';

  statusList: any[] = [
    { key: 'GENERATED', value: 'Generado' },
    // { key: 'SEND', value: 'Enviado' },
    { key: 'PAID', value: 'Pagado' },
  ];

  get status() {
    return this.statusForm.get('status') as FormControl;
  }
  get paidDate() {
    return this.statusForm.get('paidDate') as FormControl;
  }
  get paidDescription() {
    return this.statusForm.get('paidDescription') as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private consolidateService: FnConsolidatedService,
    private ipSnackbarService: IpSnackbarService,
    private dialogRef: MatDialogRef<FnStatusModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.serviceType = this.data.type;
    this.statusForm = this.fb.group({
      status: [this.data.consolidated?.is_paid ?? '', Validators.required],
      paidDate: ['', Validators.required],
      paidDescription: ''
    });
  }

  applyFilters() {
    if (this.serviceType === 'consolidated'){
      this.consolidateService
      .sendStatusChange(
        this.data.consolidated.id_consolidated,
        this.statusForm.get('status')?.value === true ? 'PAID': 'GENERATED',
        this.formatDate(this.paidDate.value),
        this.paidDescription.value === '' ? null : this.paidDescription.value
      )
      .subscribe({
        next: (a) => {
          this.ipSnackbarService.showSuccessMessage(
            `El pago del consolidado con ID: ${this.data.consolidated.id_consolidated} se registró exitosamente.`
          );
          this.dialogRef.close(true)
        },
        error: (e) => {
          this.ipSnackbarService.showErrorMessage(e);
          this.dialogRef.close()
        },
      });
    }
    if (this.serviceType === 'consolidatedItem'){
      this.consolidateService
      .payConsolidatedItem(
        this.data.consolidated.id,
        this.status.value,
        this.paidDate.value !== '' ? this.formatDate(this.paidDate.value) : null,
        this.paidDescription.value === '' ? null : this.paidDescription.value
      )
      .subscribe({
        next: () => {
          this.ipSnackbarService.showSuccessMessage(
            `El cambio de estado de pago del item del consolidado con ID: ${this.data.consolidated.id_consolidated} se registró exitosamente.`
          );
          this.dialogRef.close(true)
        },
        error: (e) => {
          this.ipSnackbarService.showErrorMessage(e);                
          this.dialogRef.close()
        },
      });
    }
  }

  formatDate(date: string): string {
    const day = this.datePipe.transform(date, 'dd');
    const month = this.datePipe.transform(date, 'MM');
    const year = this.datePipe.transform(date, 'yyyy');
    const time = this.datePipe.transform(date, 'hh:mm:ss');
    return `${year}-${month}-${day}T${time}`;
  }

  onClose(){
    this.dialogRef.close()
  }
}
